import { render } from "./WorkflowSubmission.vue?vue&type=template&id=0e11785e&ts=true"
import script from "./WorkflowSubmission.vue?vue&type=script&lang=ts"
export * from "./WorkflowSubmission.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__